import { render, staticRenderFns } from "./DiscountRuleTemplateDetail.vue?vue&type=template&id=56c45438&scoped=true&"
import script from "./DiscountRuleTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./DiscountRuleTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiscountRuleTemplateDetail.vue?vue&type=style&index=0&id=56c45438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c45438",
  null
  
)

export default component.exports